import React from 'react';
import { InfinitySpin } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { CreateMacue } from '../../../redux/admin/macue/macue_services_sync';

const baseSchema = Yup.object({
  title: Yup.string().required(),
});

const Create_Macue = () => {
  const dispatch = useDispatch();

  const { macue_loader } = useSelector((state) => state.macue);

  const handleSubmited = async (value, { resetForm }) => {
    // e.preventDefault();

    if (macue_loader) return;

    const payload = {
      ...value,
    };

    await dispatch(CreateMacue({ ...payload }));

    resetForm();

    // router.push('/admin_dashboard/users');
  };

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
  } = useFormik({
    initialValues: {
      title: '',
    },
    validationSchema: baseSchema,
    onSubmit: handleSubmited,
  });

  return (
    <>
      <div class="row">
        <div class="col-xl-9 col-lg-8 ">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">General Information</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-12">
                  <div class="mb-0">
                    <label for="description" class="form-label">
                      Title
                    </label>
                    <textarea
                      class="form-control bg-light-subtle"
                      id="description"
                      rows="7"
                      placeholder="Type Title"
                      value={values.title || ''}
                      onChange={handleChange}
                      name="title"
                      style={{
                        border: errors.title && '1px solid red',
                      }}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-3 bg-light mb-3 rounded">
            <div class="row justify-content-end g-2">
              <div class="col-lg-2">
                <a class="btn btn-primary w-100" onClick={handleSubmit}>
                  {macue_loader ? (
                    <div class="form-group col-sm-9">
                      <InfinitySpin width="100" color="#FE6B30" />
                    </div>
                  ) : (
                    <>Upload Macue</>
                  )}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Create_Macue;
